import React, { Component } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Link } from "react-router-dom";
import classNames from 'classnames';
import { showModal, MODAL_QUIZ_DELETE } from '../../../../modules/modals';
import { connect } from 'react-redux'
import moment from 'moment';
import { MoreOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';

class Quiz extends Component {
  render() {
    const {quiz, index} = this.props;
    return (
      <Draggable draggableId={'quiz-'+ quiz.id} index={index}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
          > 
          <div className="quiz" style={{background: quiz.color}}>
            <div className="title">
              <MoreOutlined />
              <div {...provided.dragHandleProps} > {quiz.title}</div> 
            </div>
            <div className="actions">
              <div className={classNames("point", {
                red: !quiz.active || !(quiz.active && moment() >= moment(quiz.active_from * 1000) && moment() <= moment(quiz.active_to * 1000)), 
                green: quiz.active && moment() >= moment(quiz.active_from * 1000) && moment() <= moment(quiz.active_to * 1000),
              })} />
              <div className="btn-icon" onClick={() => {
                const {showModal} = this.props;
                showModal({
                  modalType : MODAL_QUIZ_DELETE,
                  modalProps : {
                    quiz_id: quiz.id,
                    deleteQuiz: this.props.deleteQuiz
                  }
                })
              }}>
                <DeleteOutlined/>
              </div>
              
              <Link to={`/quiz/${quiz.id}`} className="btn-icon">
                <EditOutlined />
              </Link>
            </div>
          </div>
          </div>
        )}
      </Draggable>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  
})

const mapDispatchToProps = {
  showModal
}

export default connect(mapStateToProps, mapDispatchToProps)(Quiz)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Quizs/components/Room/Quiz.jsx